const EventDetailFAQLink = () => (
  <div className="w-full">
    <div className="text-2xl mb-4 capitalize dark:text-white">FAQ</div>
    <div className="dark:text-white text-black whitespace-pre-wrap font-medium">
      <p>
        Click{" "}
        <a
          href="https://themoongate.notion.site/Moongate-FAQs-ffbb9d4ba5084b8abf5a46829c923486"
          target="_blank"
          rel="noreferrer"
          className="text-primary underline cursor-pointer"
        >
          here
        </a>{" "}
        to see complete FAQ
      </p>
    </div>
  </div>
);

export default EventDetailFAQLink;
